import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
// import { COLORS } from '../../models/colors';

export const Link = styled(NavLink)`
`;
